module.exports = "<div class=\"form-component\">\r\n    <div class=\"fc-title\">\r\n        View Engine | {{ controlContext.title }}\r\n    </div>\r\n</div>\r\n  "


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/view-engine/viewEngine.component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/designers/view-engine/viewEngine.component.html
// module chunks = main